'use strict';

wbApp.controller('CoursesAttendanceSummaryCtrl', ['$scope', '$filter', '$translate', 'reportsSvc',
function ($scope, $filter, $translate, reportsSvc) {

    $scope.fromDate = moment().startOf('day').toDate();
    $scope.toDate = moment().startOf('day').add(3, 'days').toDate();

    $scope.filterOptions = {
        filterText: ""
    };

    $scope.onDataRangeChanged = function () {

        var mFromDate = moment($scope.fromDate);
        var mToDate = moment($scope.toDate);

        if (!!$scope.fromDate && mFromDate.isValid() && !!$scope.toDate && mToDate.isValid()) {

            if (mFromDate.isAfter(mToDate)) {
                $scope.toDate = mFromDate.toDate();
            }

            if (mToDate.diff(mFromDate, 'days') > 32) {
                $scope.toDate = mFromDate.add(31, 'days').toDate();
            }

            refreshData($scope.fromDate, $scope.toDate);
        }
    }

    $scope.gridSettings = {
        name: 'attendanceSummary',
        shouldShowColumnChooser: true,
        exportVisibleColumnsOnly: true,
        allowColumnReordering: true,
        columns: [
        {
            dataField: 'studentID',
            caption: 'studentID',
            dataType: 'string',
            visible: false,
            width: '70px'
        },
        {
            dataField: 'lessonStartDate',
            caption: $translate.instant('TXT_LBL_START_DATE'),
            dataType: 'date',
            format: { raw: "dd.MM.yy EEE HH:mm" },
            width: '130px',
            sortOrder: 'asc'
        },
        { dataField: 'lessonEndDate', caption: $translate.instant("TXT_LBL_END_DATE"), dataType: 'date', format: { raw: "HH:mm" }, width: '60px' },
        { dataField: 'classroomName', caption: $translate.instant('TXT_LBL_CLASSROOM'), dataType: 'string', width: '180px', visible: false },
        { dataField: 'courseFullName', caption: $translate.instant('TXT_LBL_COURSE'), dataType: 'string', width: '180px' },
        { dataField: 'studentFullName', caption: $translate.instant('TXT_LBL_STUDENT'), dataType: 'string', width: '140px' },
        { dataField: 'courseTeacherFullName', caption: $translate.instant('TXT_LBL_EMPLOYEE') + ' - ' + $translate.instant('TXT_LBL_COURSE'), dataType: 'string', width: '160px' },
        { dataField: 'scheduleTeacherFullName', caption: $translate.instant('TXT_LBL_EMPLOYEE') + ' - ' + $translate.instant('TXT_LBL_LESSON'), dataType: 'string', width: '160px' },
        { dataField: 'registrationNotes', caption: $translate.instant('TXT_NOTE') + ' - ' + $translate.instant('TXT_SEC_REGISTRATION'), dataType: 'string' },
        { dataField: 'scheduleNotes', caption: $translate.instant('TXT_NOTE') + ' - ' + $translate.instant('TXT_LBL_LESSON'), dataType: 'string', visible: false },
        { dataField: 'attendanceNotes', caption: $translate.instant('TXT_NOTE') + ' - ' + $translate.instant('TXT_LBL_ATTENDANCE'), dataType: 'string', visible: false },
        { dataField: 'semesterName', caption: $translate.instant('TXT_LBL_SEMESTER'), width: '180px', visible: false },
        {
            dataField: 'courseAttendanceStatusID',
            caption: $translate.instant('TXT_COL_ATTENDANCE_STATUS'),
            dataType: 'string',
            width: '100px',
            calculateCellValue: function (rowData) {
                return $filter('attendanceStatus')(rowData.courseAttendanceStatusID);
            }
        },
        {
            dataField: 'courseAttendanceTypeID',
            caption: $translate.instant('TXT_COL_ATTENDANCE_TYPE'),
            dataType: 'string',
            width: '100px',
            calculateCellValue: function (rowData) {
                return $filter('attendanceType')(rowData.courseAttendanceTypeID);
            }
        }, {
            dataField: 'phone',
            caption: $translate.instant('TXT_LBL_PHONE'),
            dataType: 'string',
            calculateCellValue: function (rowData) {
                return $filter('phone')(rowData.phone);
            },
            width: '120px',
            visible: false
        },
        { dataField: 'email', caption: $translate.instant('TXT_LBL_EMAIL'), dataType: 'string', width: '190px', visible: false },
        { dataField: 'price', caption: $translate.instant('TXT_LBL_PRICE'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '100px', visible: false },
        { dataField: 'paymentsSum', caption: $translate.instant('TXT_LBL_PAYMENTS'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '100px', visible: false },
        { dataField: 'arrear', caption: $translate.instant('TXT_LBL_ARREAR'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '100px', visible: false },
        { dataField: 'userFullName', caption: $translate.instant('TXT_LBL_PARENT'), dataType: 'string', visible: false },
        {
            dataField: 'studentBirthday',
            caption: $translate.instant('TXT_LBL_BIRTHDAY'),
            dataType: 'date',
            format: { date: 'short' },
            width: '70px',
            alignment: 'right',
            visible: false
        },
        {
            dataField: 'studentGroups',
            caption: $translate.instant('TXT_MENU_GROUPS'),
            dataType: 'object',
            calculateCellValue: function (rowData) {
                return $filter('groups')(rowData.studentGroups);
            },
            visible: false
        },
        ]
    }

    function refreshData(fromDate, toDate) {

        var mFromDate = moment($scope.fromDate);
        var mToDate = moment($scope.toDate);

        if (mFromDate.isValid() && mToDate.isValid()) {
            $scope.cousesAttendaceSummary = reportsSvc.getCoursesAttendanceSummaryForDateRange(fromDate, toDate);
        } else {
            $scope.cousesAttendaceSummary = [];
        }
    }

    refreshData($scope.fromDate, $scope.toDate);

    $scope.$on('refreshData', function (e, data) {
        refreshData($scope.fromDate, $scope.toDate);
    });

}]);
